import './FullPageSpinner.css';

/**
 * Reserved for initial app boot / auth check only (08-staff-ux.md §10.1) — every other
 * loading state in the app uses a scoped skeleton instead.
 */
export function FullPageSpinner() {
  return (
    <div className="fa-full-page-spinner" role="status" aria-live="polite">
      <span className="fa-full-page-spinner__ring" aria-hidden="true" />
      <span className="fa-visually-hidden">Loading…</span>
    </div>
  );
}
